const ASSIGNMENT_TYPES = Object.freeze({
  location: 'location',
  device: 'device',
});

export default ASSIGNMENT_TYPES;
